export const AGENT_STATE = {
  ready: '9e7b4c65-573c-4b8d-8f5f-ca75548e8567',
  busy: '7d0ccb62-75ba-4871-8941-ff386fee92db',

  offline: 'f05810d5-0528-44eb-8a20-658b37a03e2d',
  waitingForOffline: 'c4200053-2256-4216-8e38-99fcc5665ee3',

  backoffice: '1e3791af-6f47-4cca-9080-5a2f22f54c8a',
  waitingForBackoffice: '25f6a341-5691-4120-8690-c6008dd4c52a',

  break: 'e3087192-fad7-41a0-8d20-cba96bcd2239',
  waitingForBreak: '1df09cc7-732f-4c74-a5b1-bd4acf8c744f',

  outgoing: '0bbe0538-c089-4281-b49c-1ebc236d638b',
  waitingForOutgoing: '3536f947-7bdf-4b2c-bc16-9c73139a43ed',

  preview: '31abefd5-9f32-4bef-a14b-3ad7e9e01315',
  dialing: '8777eaae-4a72-4194-a64b-326a08e1d6ee',
  offered: 'dbff52e1-5471-4e3c-a1ef-041ee60c3fbe',
  noAnswer: '2a2e8773-a35e-4d3f-a5c3-d55621040935'
};
